import { createAction, props } from '@ngrx/store'
import { TableNumbersEntity } from './table-numbers.models'
import { HttpErrorResponse } from '@angular/common/http'

export const loadTableNumbers = createAction('[TableNumbers Page] Init')

export const loadTableNumbersSuccess = createAction(
  '[TableNumbers/API] Load TableNumbers Success',
  props<{ tableNumbers: TableNumbersEntity[] }>(),
)

export const loadTableNumbersFailure = createAction(
  '[TableNumbers/API] Load TableNumbers Failure',
  props<{ error: HttpErrorResponse }>(),
)
